.letters {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
